console.log("Conversation Memory Loaded");

const AI_MEMORY = {

    lastIntent: null,

    lastCategory: null,

    lastRequirement: null,

    lastProducts: [],

    lastProduct: null

};

//----------------------------------------
// GET CHEAPEST PRODUCT
//----------------------------------------

function getCheapestProduct(){

    if(!AI_MEMORY.lastProducts.length){

        return null;

    }

    const products = AI_MEMORY.lastProducts
        .map(item => item.product);

    products.sort((a,b)=>{

        const priceA = parseFloat(a.variants[0].price);

        const priceB = parseFloat(b.variants[0].price);

        return priceA - priceB;

    });

    return products[0];

}

//----------------------------------------
// FOLLOW-UP DETECTION
//----------------------------------------

function isCheapestQuestion(message){

    message = message.toLowerCase();

    return (

        message.includes("cheapest") ||

        message.includes("lowest price") ||

        message.includes("lowest") ||

        message.includes("budget") ||

        message.includes("least expensive") ||

        message.includes("low price")

    );

}